import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import CustomDynamicLocationCredentialsStore
    from '../../../stores/credentials/custom-dynamic-location-credentials-store';

interface IIntegrationProps {
    credentialsStore: CustomDynamicLocationCredentialsStore,
    vGroup: IValidationGroup,
}

const CustomDynamicLocationCredentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    return (
        <>
            <FormFieldLine
                label='Password for Basic authentication'
                note='Your API password'
                required
                key='password'
            >
                <Input
                    value={credentialsStore.password}
                    placeholder=''
                    onChange={v => credentialsStore.password = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                label='Username for Basic authentication'
                note='Your API Username'
                required
                key='username'
            >
                <Input
                    value={credentialsStore.username}
                    placeholder=''
                    onChange={v => credentialsStore.username = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                label='Full endpoint URL to get dynamic location'
                note='Endpoint url'
                required
                key='url'
            >
                <Input
                    value={credentialsStore.url}
                    placeholder=''
                    onChange={v => credentialsStore.url = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
        </>
    )
});

export default CustomDynamicLocationCredentials;
